<template>
  <form>
    <v-row>
      <v-col
        cols="6"
        class="pb-0"
      >
        <v-menu
          v-model="rehireDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="rehireDateDisplay"
              v-validate="'required'"
              :error-messages="errors.collect('rehireDateDisplay')"
              data-vv-name="rehireDateDisplay"
              data-vv-as="rehire date"
              label="Rehire Date"
              placeholder="YYYY-MM-DD"
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="rehireDate"
            class="datepicker"
            no-title
            :min="rehireMinDate"
            :max="today"
            @input="rehireDateMenu = false"
          />
        </v-menu>
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="employee.superior"
          v-validate="'required'"
          label="New Superior"
          :items="employees"
          :error-messages="errors.collect('superior')"
          data-vv-name="superior"
          data-vv-as="superior"
          hide-no-data
          hide-selected
          item-text="person.name" 
          item-value="employee_uid" 
        />
      </v-col>
                  
      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="employee.position"
          v-validate="'required'"
          label="New Position"
          :items="positions"
          item-text="name" 
          item-value="id" 
          :error-messages="errors.collect('position_id')"
          data-vv-name="position_id"
          data-vv-as="position"
          return-object
          @input="probationPeriodDisplay(employee.position)"
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="employee.probation_period"
          v-validate="'required'"
          label="Probation Period"
          :items="probationPeriods"
          :error-messages="errors.collect('probation_period')"
          data-vv-name="probation_period"
          data-vv-as="probation period"
          item-text="name"
          item-value="id"
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="employee.department_id"
          v-validate="'required'"
          label="New Department"
          :items="departments"
          item-text="name" 
          item-value="id" 
          :error-messages="errors.collect('department_id')"
          data-vv-name="department_id"
          data-vv-as="department"
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-if="employee.department_id"
          v-model="employee.section_id"
          label="New Department Section"
          :items="filteredSections"
          item-text="name" 
          item-value="id" 
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="employee.base_location_state"
          v-validate="'required'"
          label="New Base Location (State)"
          :error-messages="errors.collect('base_location_state')"
          data-vv-name="base_location_state"
          data-vv-as="base location (state)"
          :items="states"
          item-text="name" 
          item-value="id" 
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-if="employee.base_location_state"
          v-model="employee.base_location_city"
          v-validate="'required'"
          label="New Base Location (City)"
          :items="filteredCities"
          :error-messages="errors.collect('base_location_city')"
          data-vv-name="base_location_city"
          data-vv-as="base location (city)"
          item-text="name" 
          item-value="id" 
        />
      </v-col>
    </v-row>

    <v-row class="text-right">
      <v-col cols="12">
        <v-btn 
          text
          class="px-10"  
          @click="closeDialog"
        >
          cancel
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="white--text px-10"
          @click="goNext"
        >
          next
        </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
  export default {
    components: {
    },
    $_veeValidate: {
      validator: 'new', // give me my own validator scope.
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      rehireMinDate: {
        type: String, 
        default: '',
      },
    },
    data () {
      return {
        today: new Date().toISOString().slice(0, 10), 
        mask: '####-##-##',
        employee: {
          join_date: null,
          department_id: null,
          section_id: null,
          position_id: null,
          probation_period: null,
          base_location_state: null,
          base_location_city: null,
          workday_id: null,
          superior: null,
        },
        departments: [],
        positions: [],
        states: [],
        cities: [],
        employees: [],
        rehireDateMenu: false,
        rehireDate: null,
        probationPeriods: [
          { id: 1, value: 3, name: '3 Months' },
          { id: 2, value: 6, name: '6 Months' },
        ],
      }
    },
    computed: {
      filteredCities () {
        return this.cities.filter(city => {
          return city.state_id === this.employee.base_location_state
        })
      },
      rehireDateDisplay () {
        return this.rehireDate ? this.$moment(this.rehireDate).format('YYYY-MM-DD') : ''
      },
      filteredSections () {
        return this.sections.filter(section => {
          return section.department_id === this.employee.department_id
        })
      },
    },

    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.hrisEmployees().show(this.employeeUid),  
          this.$api.hrisDepartments().list(),  
          this.$api.hrisPositions().list(),  
          this.$api.hrisCities().list(),
          this.$api.hrisStates().list(),
          this.$api.hrisEmployees().list('?with=vessel'),
          this.$api.hrisSections().list(),
        ]).then(([employee, department, position, city, state, superior, section]) => {
          this.employee.join_date = employee.data.joined_date

          this.departments = _.orderBy(department.data, ['name'], ['asc'])
          this.positions = _.orderBy(position.data, ['name'], ['asc'])
          this.states = _.orderBy(state.data, ['name'], ['asc'])
          this.cities = _.orderBy(city.data, ['name'], ['asc'])

          this.sections = _.orderBy(section.data, ['name'], ['asc'])
          this.employees = _.orderBy(superior.data, ['person.name'], ['asc'])
        })
      },

      closeDialog () {
        this.$emit('close-dialog')
      },

      goNext () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.$emit('next-step')
        })
      },

      getFormData () {
        return {
          joined_date: this.rehireDate,
          department_id: this.employee.department_id,
          section_id: this.employee.section_id, 
          state_id: this.employee.base_location_state,
          city_id: this.employee.base_location_city,
          superior_id: this.employee.superior,
          position_id: this.employee.position.id,
          probation_period: this.employee.probation_period === 1 ? 3 : 6,
        }
      },
    
      isValidDate (value) {
        return this.$moment(value).format('YYYY-MM-DD') >= this.$moment(this.rehireDate).format('YYYY-MM-DD')
      },
      
      probationPeriodDisplay (selectedPosition) {
        if (selectedPosition.job_grade.job_category.name === 'Non Executive') {
          this.employee.probation_period = 1
        } else {
          this.employee.probation_period = 2
        }
      },
    },
  }
</script>
